import type { CreateNotificationBodyContentData } from './createNotificationBodyContentData';

export type CreateNotificationBodyContent = {
  body?: string;
  /** @nullable */
  data?: CreateNotificationBodyContentData;
  /** @nullable */
  summary?: string | null;
};
